import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getEventTemplates } from '@pingum/app-state-management/eventTemplate/actions';
import { getStatuses } from '@pingum/app-state-management/status/actions';
import EventTemplateSettingsHeader from './components/EventTemplateSettingsHeader';
import EventTemplateList from './components/EventTemplateList';
import Page from '../../widgets/Page';

export class EventTemplateSettingsComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pagination: {
        page: 0,
        size: 10,
        search: '',
        sort: ['name,asc'],
      },
      selectedWorkflows: [],
    };

    if (!props.isFetchingEventTemplates) {
      props.getEventTemplates(
        props.includeArchived,
        this.state.pagination,
      );
    }
    if (props.statuses.length === 0) {
      props.getStatuses();
    }
  }

  handlePaginationUpdate = (includeArchived, pagination) => {
    this.setState({ pagination }, () => {
      this.props.getEventTemplates(includeArchived, this.state.pagination);
    });
  }

  handleSelectedWOrkflowsChange = (selectedWorkflows) => {
    this.setState({ selectedWorkflows });
  }

  render() {
    const {
      includeArchived,
      eventTemplates,
      isFetchingEventTemplates,
      isAddingEventTemplate,
      isEditingEventTemplate,
      isDeletingEventTemplate,
      statuses,
    } = this.props;

    const {
      pagination,
      selectedWorkflows,
    } = this.state;

    const isLoading = isFetchingEventTemplates
      || isAddingEventTemplate
      || isEditingEventTemplate
      || isDeletingEventTemplate;

    return (
      <Page title="Workflows" showLoadingIndicator={isLoading}>
        <EventTemplateSettingsHeader
          onPaginationUpdate={this.handlePaginationUpdate}
          pagination={pagination}
          includeArchived={includeArchived}
          selectedWorkflows={selectedWorkflows}
        />
        <EventTemplateList
          onPaginationUpdate={this.handlePaginationUpdate}
          onSelectedWorkflowsChange={this.handleSelectedWOrkflowsChange}
          includeArchived={includeArchived}
          eventTemplates={eventTemplates}
          pagination={pagination}
          loading={isLoading}
          statuses={statuses}
        />
      </Page>
    );
  }
}

EventTemplateSettingsComponent.propTypes = {
  getEventTemplates: PropTypes.func.isRequired,
  eventTemplates: PropTypes.object,
  isFetchingEventTemplates: PropTypes.bool,
  isAddingEventTemplate: PropTypes.bool,
  isEditingEventTemplate: PropTypes.bool,
  isDeletingEventTemplate: PropTypes.bool,
  includeArchived: PropTypes.bool,
  statuses: PropTypes.array,
  getStatuses: PropTypes.func,
};

EventTemplateSettingsComponent.defaultProps = {
  eventTemplates: { content: [] },
  isFetchingEventTemplates: false,
  isAddingEventTemplate: false,
  isEditingEventTemplate: false,
  isDeletingEventTemplate: false,
  includeArchived: false,
  statuses: [],
  getStatuses: () => {},
};

export const mapStateToProps = (state) => ({
  isFetchingEventTemplates: state.eventTemplate.isFetchingEventTemplates,
  isAddingEventTemplate: state.eventTemplate.isAddingEventTemplate,
  isEditingEventTemplate: state.eventTemplate.isEditingEventTemplate,
  isDeletingEventTemplate: state.eventTemplate.isDeletingEventTemplate,
  eventTemplates: state.eventTemplate.eventTemplatesPageable,
  includeArchived: state.eventTemplate.includeArchived,
  statuses: state.status.statuses,
});

export const mapDispatchToProps
  = (dispatch) => ({
    getEventTemplates: (includeArchived, pagination) => dispatch(getEventTemplates(includeArchived, pagination)),
    getStatuses: () => dispatch(getStatuses(false)),
  });

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventTemplateSettingsComponent);
